export default "__VITE_ASSET__CQ4ST6OJ__"